import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const RoleGuard = ({ children, allowedRoles, fallback = null }) => {
  const { user } = useAuth();
  
  if (!user) {
    return fallback;
  }
  
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return fallback;
  }
  
  return children;
};

export default RoleGuard;